import Vue from "vue";
import Vuex from "vuex";
import chat from "./modules/chat";
import app from "./modules/app";
import site from "./modules/site";
import language from "./modules/language";
import setting, { installColorSchemeWatcher } from "./modules/setting";
import catalog from "./modules/catalog";
import customLoginForm from "./modules/customLoginForm";
import webrtc from "./modules/webrtc";
import voiceRecorder from "./modules/voiceRecorder";
import shell from "./modules/shell";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
    modules: {
        chat,
        app,
        site,
        setting,
        language,
        catalog,
        customLoginForm,
        webrtc,
        voiceRecorder,
        shell,
    },
    strict: debug,
});
installColorSchemeWatcher(store);
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js